import React from "react";
import { Box, Typography } from "@mui/material";

const LabelPreview = ({ deviceNumber, config }) => {
  const { LABEL_TEXT_LINE1, LABEL_TEXT_LINE2, QR_BASE_URL } = config;

  return (
    <Box
      sx={{
        width: 340,
        height: 200,
        bgcolor: "white",
        border: "1px solid #ddd",
        borderRadius: "12px",
        position: "relative",
        display: "flex",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        background: "#ffffff",
        overflow: "hidden",
      }}
    >
      {/* Eldan Logo */}
      <Box
        sx={{
          position: "absolute",
          top: 15,
          right: 130,
          width: 90,
          height: 50,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        <img
          src="/utils/eldan_logo.png"
          alt="Eldan Logo"
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "100%",
            objectFit: "contain",
          }}
        />
      </Box>
            {/* Device Text - Left side, below logo */}
      <Box
        sx={{
          position: "absolute",
          left: 130,
          top: 70,
          width: 180,
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
          textAlign: "right",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Arial, sans-serif",
            fontSize: "25px",
            fontWeight: "normal",
            color: "#000",
            lineHeight: 1.2,
            margin: 0,
          }}
        >
          {LABEL_TEXT_LINE1 || "US1449U209"}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Arial, sans-serif",
            fontSize: "25px",
            fontWeight: "normal",
            color: "#000",
            lineHeight: 1.2,
            margin: 0,
          }}
        >
          {LABEL_TEXT_LINE2 || "G7010AA"}
        </Typography>
      </Box>

      {/* QR Code - Right side */}
      <Box
        sx={{
          position: "absolute",
          right: 220,
          top: "50%",
          transform: "translateY(-50%)",
          width: 100,
          height: 100,
          bgcolor: "#000",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Realistic QR code pattern */}
        <Box
          sx={{
            width: "96%",
            height: "96%",
            bgcolor: "white",
            position: "relative",
            display: "grid",
            gridTemplateColumns: "repeat(25, 1fr)",
            gridTemplateRows: "repeat(25, 1fr)",
            gap: 0,
          }}
        >
          {Array.from({ length: 625 }, (_, i) => {
            const row = Math.floor(i / 25);
            const col = i % 25;

            // Create finder patterns (corners) - 7x7 squares
            const isFinderPattern =
              (row < 7 && col < 7) ||
              (row < 7 && col > 17) ||
              (row > 17 && col < 7);

            // Finder pattern details
            const isFinderBorder =
              isFinderPattern &&
              (row === 0 ||
                row === 6 ||
                col === 0 ||
                col === 6 ||
                row === 18 ||
                row === 24 ||
                col === 18 ||
                col === 24);

            const isFinderCenter =
              isFinderPattern &&
              ((row >= 2 && row <= 4 && col >= 2 && col <= 4) ||
                (row >= 2 && row <= 4 && col >= 20 && col <= 22) ||
                (row >= 20 && row <= 22 && col >= 2 && col <= 4));

            // Timing patterns
            const isTimingPattern =
              (row === 6 || col === 6) && !isFinderPattern;

            // Random data pattern for the rest
            const isDataModule =
              !isFinderPattern && !isTimingPattern && Math.random() > 0.5;

            const shouldBeFilled =
              isFinderBorder ||
              isFinderCenter ||
              (isTimingPattern && (row + col) % 2 === 0) ||
              isDataModule;

            return (
              <Box
                key={i}
                sx={{
                  bgcolor: shouldBeFilled ? "#000" : "#fff",
                }}
              />
            );
          })}
        </Box>
      </Box>

      {/* Hebrew instructions at bottom */}
      <Box
        sx={{
          position: "absolute",
          bottom: 12,
          left: 50,
          right: 50, // Leave space for QR code on right
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Arial, sans-serif",
            fontSize: "11px",
            fontWeight: "normal",
            color: "#000",
            direction: "rtl",
            textAlign: "center",
          }}
        >
          נא לסרוק את הקוד כדי לפתוח קריאה
        </Typography>
      </Box>

    </Box>
  );
};

export default LabelPreview;